import { useState, useEffect } from 'react'

const DAYS_ES = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
]

export function useTimezone() {
  const [dayName, setDayName] = useState<string>('')

  useEffect(() => {
    async function fetchDay() {
      try {
        // Use ipapi.co (already used for pricing) to get timezone
        const res = await fetch('https://ipapi.co/json/', {
          signal: AbortSignal.timeout(3000),
        })
        if (res.ok) {
          const data = await res.json()
          const tz: string = data.timezone || ''
          if (tz) {
            // Get current date in the visitor's real timezone
            const formatter = new Intl.DateTimeFormat('en-US', {
              timeZone: tz,
              weekday: 'long',
            })
            const englishDay = formatter.format(new Date())
            const dayIndex = [
              'Sunday',
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
            ].indexOf(englishDay)
            if (dayIndex !== -1) {
              setDayName(DAYS_ES[dayIndex])
              return
            }
          }
        }
      } catch {
        // fall through to browser fallback
      }
      // Fallback: use browser's local time
      setDayName(DAYS_ES[new Date().getDay()])
    }

    fetchDay()
  }, [])

  return { dayName }
}
